import React from 'react'

const IconBooking = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" 
        height="32px"
        viewBox="0 0 490.6 492.6"
        >	
        <style>
            {`
                .booking_st0 {
                    fill: #00427F;
                }
                
                .booking_st1 {
                    fill: #009FDD;
                }
            `}
        </style>
            <g>
                <path className="booking_st0" d="M0,492.6c0-2.6,0-4.5,0-6.3C0,353.5,0,220.7,0,87.8C0,44.4,28.6,9.6,71.2,1.4c5-1,10.3-1.3,15.4-1.4C192.4,0,298.2,0,404,0c48,0,86.5,38.4,86.5,86.4c0.1,106.7,0.1,213.3,0,320c0,47.9-38.5,86.2-86.6,86.2c-132.8,0.1-265.6,0-398.5,0C3.8,492.6,2.2,492.6,0,492.6z M263.4,238.1c2.6-2.3,4.6-4,6.6-5.8c26.7-23.4,27.1-75-9.9-96c-11.8-6.7-24.6-10.3-38.1-10.6c-21-0.4-42-0.3-63-0.2c-16,0-26.4,10.7-26.4,26.9c0,68.8,0,137.7,0,206.5c0,1.8,0.2,3.5,0.3,5.8c2.7,0,4.8,0,6.9,0c23.7,0,47.3,0.1,71-0.1c8-0.1,16-0.4,23.9-1.6c38-5.7,66.2-31.5,63.2-74.1c-1.5-20.4-10.4-36.6-28.4-47.1C267.7,240.6,265.8,239.5,263.4,238.1z M377.9,338.2c0-16-12.1-28.3-27.9-28.3c-16.1-0.1-28.4,12.2-28.4,28.4c0,15.8,12.3,28.4,27.9,28.5C365.4,366.7,377.9,354.2,377.9,338.2z" />
                <path className="booking_st0" d="M179.1,323.3c0-17.2-0.3-33.8,0.1-50.4c0.2-8.4,5-13.3,13.1-13.6c10.1-0.3,20.3-0.4,30.4,0.4c21.2,1.5,29.4,18.4,27.6,35.6c-1.8,17.1-10.8,26.6-27.8,27.9C208.3,324.2,193.9,323.3,179.1,323.3z" />
                <path className="booking_st0" d="M179.1,221.6c0-14.8-0.4-29.1,0.1-43.4c0.3-8,4.7-12.5,12.7-12.9c9.8-0.5,19.7-0.4,29.4,0.7c10.4,1.2,17,7.9,19.4,18.1c1.9,7.8,1.4,15.5-1.9,22.9c-4,8.9-11.1,13.9-20.6,14.3C205.4,222,192.6,221.6,179.1,221.6z" />
            </g>
            <circle className="booking_st1" cx="349.9" cy="338.1" r="28.5" />
        </svg>
    )
} 

export default IconBooking